module.exports = __webpack_public_path__ + "img/users-purple.62173a2a.svg";